import { FC } from 'react';

import ModalButtonsWrapper from 'components/curo-components/common/ModalButtonsWrapper';
import Button from 'components/digifi-wrappers/Button';
import { useDisableBodyScroll } from 'hooks/useDisableBodyScroll';
import { ConsentOfESignaturesContent } from 'pages/CuroPages/PoliciesPage/content/ConsentOfESignatures';
import { CloseIcon } from 'static/images';

import styles from './TermsPopUp.module.scss';

interface ITermsPopUp {
  onClose: () => void;
  onAgreeClick: () => void;
}

const TermsPopUp: FC<ITermsPopUp> = ({ onClose, onAgreeClick }) => {
  useDisableBodyScroll();

  return (
    <div className={styles.modalWrapper} onClick={onClose} role="button" tabIndex={0}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.contentHeader}>
          <button onClick={onClose}>
            <CloseIcon className={styles.closeIcon} />
          </button>
        </div>
        <div className={styles.contentBody}>
          <h5 className={styles.modalTitle}>
            Consent for Electronic Signatures, Records, and Disclosures ("E-Consent")
          </h5>
          <div className={styles.modalDescription}>
            <ConsentOfESignaturesContent />
          </div>
          <ModalButtonsWrapper position="flex-start">
            <Button size="form" kind="primary" onClick={onAgreeClick}>
              I agree
            </Button>
            <a
              href={'/Consent-for-Electronic-Signatures.pdf'}
              target="_blank"
              title="Consent for Electronic Signatures"
            >
              <Button size="form" kind="secondary">
                Download E-Consent
              </Button>
            </a>
          </ModalButtonsWrapper>
        </div>
      </div>
    </div>
  );
};

export default TermsPopUp;
